import { Intro } from 'components/commons';
import React from 'react';

import TransactionEntryForm from './transaction-entry-form';

const TransactionEntryModule = () => {
  return (
    <div>
      <div>
        <Intro
          title={'Transaction Entry'}
          subtitle={
            'Manage financial transactions linked to your chart of accounts. Keep your records accurate and up to date for clear financial tracking.'
          }
        />
      </div>

      <TransactionEntryForm />
    </div>
  );
};

export default TransactionEntryModule;
